import { TableSortingState } from '@ibsys/kit';
import type { KnowledgeSourceSort, SortField } from '@/entities/search';

/**
 * Колонки списка источников, по которым сервер упорядочивает выдачу. Порядок по колонке вне
 * этого перечня сервер отклоняет, поэтому такой ключ в запрос не уходит: список показывает
 * колонку-действие, порядка по которой не существует.
 */
const SORT_FIELDS = ['fileName', 'sourceType', 'size', 'createdAt'] as const;

type KnowledgeSourceSortField = (typeof SORT_FIELDS)[number];

const isSortField = (id: string): id is KnowledgeSourceSortField => (SORT_FIELDS as readonly string[]).includes(id);

/** Порядок источников знаний в той записи, которую разбирает сервер */
export const buildKnowledgeSourceSort = (sorting: TableSortingState): KnowledgeSourceSort | undefined => {
  if (!sorting?.length) return undefined;

  const result: KnowledgeSourceSort = {};

  for (const item of sorting) {
    if (!isSortField(item.id)) continue;
    const sortField: SortField = { sort: item.desc ? 'desc' : 'asc' };
    result[item.id] = sortField;
  }

  return Object.keys(result).length > 0 ? result : undefined;
};
